// extracted by mini-css-extract-plugin
export default {"main":"paa-z"};